import { FETCH_BASICINFO } from "../actions/WordPressApiAction";
const initialCategoriesReducer = {
  site_title: "",
  site_url: "",
  site_img: "",
  description: "",
  recommend_posts: [1926],
  header_info: [],
  profile_info: {
    name: "",
    img: "",
    background_img: "",
  },
};

export default function fetchBasicInfoReducer(
  state = initialCategoriesReducer,
  action
) {
  switch (action.type) {
    case FETCH_BASICINFO:
      return action.basicInfo;
    default:
      return state;
  }
}
